import { MetricDetails } from '../../../../api/metrics/types';
import { LanguageString } from '../../dashboards/types';
import { MetricId } from '../../metrics/types';
import { FactboxFontSizes } from '../../ui-components/data-viz-ui/factboxes/common/types';
import {
  ExternalChartComponentProps,
  KpiComponentSectionConfig,
  KpiSectionValue,
} from '../common/types';

export type KpiFactboxSingleMetricVizExternalProps =
  ExternalChartComponentProps;

export interface KpiFactboxSingleMetricVizConfig {
  title?: LanguageString;
  subtitle?: LanguageString;
  footer?: LanguageString;
  section: KpiComponentSectionConfig;
  fontSize?: FactboxFontSizes;
}

export type KpiFactboxSingleMetricVizDataResponse = {
  sectionValue: KpiSectionValue;
};

export type KpiFactboxSingleMetricVizData = {
  title?: string;
  subtitle?: string;
  footer?: string;
  fontSize?: FactboxFontSizes;
  dataResponse: KpiFactboxSingleMetricVizDataResponse;
  metricDetailsMap: Partial<Record<MetricId, MetricDetails>>;
};

export enum KpiFactboxSingleMetricVizViews {
  FACTBOX = 'factbox',
}
